<template>
  <div class="my-3">
    <p class="mb-1 fw-bold">Latest Update</p>
    <div class="d-flex justify-content-between">
      <div class="form-inline me-4">
        <label class="mr-2">Starting Date: </label>
        <input :value="statusDetails.start" class="form-control" type="date"
               @change="(event) => updateStartingDate(event.target.value)">
      </div>
      <div class="form-inline">
        <label class="mr-2">Ending Date:</label>
        <input :value="statusDetails.end" class="form-control" type="date"
               @change="(event) => updateEndingDate(event.target.value)">
      </div>
    </div>
  </div>
</template>

<script>
import {addOrUpdateParameter} from "@/helpers/urlParamsHelper";


export default {
  name: "LatestUpdate",

  computed: {
    statusDetails: function() {
      return this.$store.getters["search/getLatestUpdate"];
    }
  },

  methods: {

    // Sets the starting date for the latest update
    updateStartingDate(value) {
      this.$store.dispatch('search/updateLatestUpdateDateStart', value);

      // Adds the new value as parameters to the URI
      const encodedParams = encodeURI(value);
      addOrUpdateParameter("latestUpdateStart", encodedParams);
    },

    // Sets the ending date for the latest update
    updateEndingDate(value) {
      this.$store.dispatch('search/updateLatestUpdateDateEnd', value);

      // Adds the new value as parameters to the URI
      const encodedParams = encodeURI(value);
      addOrUpdateParameter("latestUpdateEnd", encodedParams);
    }

  }

}
</script>
